var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Auth, Layout, Dependencies } from "~/core/decorator";
import NumberRange from "~/components/common/number-range.vue";
import AddSettle from "~/components/system-manage/outsource-settle/add-settle.vue";
import { State } from "vuex-class";
import { PageService } from "~/utils/page.service";
import { SystemParamService } from "~/services/management-service/system-param.service";
import { OutsourceSettleService } from "~/services/management-service/outsource-settle.service";
import { PrincipalService } from "~/services/domain-service/principal.service";
import { OutsourceSettleManageService } from "~/services/domain-service/outsource-settle-manage.service";
import { CommissionStrategyService } from "~/services/domain-service/commission-strategy.service";
var OutSourceSettle = /** @class */ (function (_super) {
    __extends(OutSourceSettle, _super);
    function OutSourceSettle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // dialog信息
        _this.dialog = {
            addSettle: false,
            type: "ADD",
            buttonType: new Map([["ADD", "新增委外结算策略"], ["EDIT", "编辑委外结算策略"], ["VIEW", "查看委外结算策略"]])
        };
        _this.queryModel = {
            strategyName: '',
            outsourceId: '',
            commonState: '',
        };
        // 数据列表
        _this.dataSet = [];
        // 选中数据
        _this.rowData = [];
        // 佣金策略
        _this.commissionSet = [];
        return _this;
    }
    OutSourceSettle.prototype.mounted = function () {
        this.refreshData();
        this.getCommissionName();
    };
    Object.defineProperty(OutSourceSettle.prototype, "title", {
        get: function () {
            return this.dialog.buttonType.get(this.dialog.type);
        },
        enumerable: false,
        configurable: true
    });
    OutSourceSettle.prototype.refreshData = function () {
        var _this = this;
        this.outsourceSettleService.getSettlementStrategyPageList(this.queryModel, this.pageService).subscribe(function (data) { return _this.dataSet = data; });
    };
    /**
     * 获取佣金策略
     */
    OutSourceSettle.prototype.getCommissionName = function () {
        var _this = this;
        this.commissionStrategyService.selectCommissionStrategyList().subscribe(function (data) { return _this.commissionSet = data; });
    };
    __decorate([
        Dependencies(SystemParamService)
    ], OutSourceSettle.prototype, "sysParamService", void 0);
    __decorate([
        Dependencies(PageService)
    ], OutSourceSettle.prototype, "pageService", void 0);
    __decorate([
        Dependencies(OutsourceSettleService)
    ], OutSourceSettle.prototype, "outsourceSettleService", void 0);
    __decorate([
        Dependencies(PrincipalService)
    ], OutSourceSettle.prototype, "PrincipalService", void 0);
    __decorate([
        Dependencies(OutsourceSettleManageService)
    ], OutSourceSettle.prototype, "outsourceSettleManageService", void 0);
    __decorate([
        Dependencies(CommissionStrategyService)
    ], OutSourceSettle.prototype, "commissionStrategyService", void 0);
    __decorate([
        State
    ], OutSourceSettle.prototype, "outSourceList", void 0);
    OutSourceSettle = __decorate([
        Auth(16),
        Layout("workspace"),
        Component({
            components: {
                NumberRange: NumberRange,
                AddSettle: AddSettle
            }
        })
    ], OutSourceSettle);
    return OutSourceSettle;
}(Vue));
export default OutSourceSettle;
